<template>
    <span>{{time_countdown_txt}}</span>
</template>

<script>
import { convertSecondToText2 } from '../../utils/utils'

export default {
    name: "Countdown",
    props: [
        'live_class'
    ],
    data() {
        const time_current = Math.floor(Date.now() / 1000);
        const time_countdown = this.live_class.time_start - time_current;

        return {
            time_countdown: time_countdown,
            time_countdown_txt: convertSecondToText2(time_countdown)
        };
    },

    watch: {
        time_countdown: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.time_countdown--;
                        this.time_countdown_txt = convertSecondToText2(this.time_countdown) || '';
                    }, 1000);
                }else{
                    this.live_class.status = 2;
                }
            },
            immediate: true // This ensures the watcher is triggered upon creation
        },
    },

    created() {},

    methods: {

    }
}
</script>

<style scoped>

</style>
